import { SonarNotification } from '../@types';
import { CollectionResponse, createGetEndpoint } from '@sonar-software/sonar-http';

export type GetNotificationsResponse = CollectionResponse<SonarNotification>;

export const getNotifications = createGetEndpoint<void, GetNotificationsResponse>('/api/v3/notifications', {
	skipAuthRefresh: true
});
